const useStyles = {
  logo: {
    maxWidth: 150,
  },
};

export { useStyles };
